import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { closeSidebarMenus } from '../../actions/common';
import { addEntity } from '../../actions/grid-screen';
import {
    AddCampaignTypeMenu,
    AddCampaignTypeMenuProps
} from '../../components/AddCampaignTypeMenu/AddCampaignTypeMenu';
import { checkIsCampaignAddAllowedInDna } from '../../service/CampaignsEditHelpers/CampaignsEditHelpers';
import { CampaignType } from '../../typings/domain';
import { OperatorFeaturesFragment } from '../../typings/graphql-grid';
import { GridEditedEntityType } from '../../typings/grid';
import { ClientFeatures, State } from '../../typings/state';
import { TStateProps } from '../../typings/utils';

type StateProps = TStateProps<AddCampaignTypeMenuProps> & {
    clientLogin?: string;
    operatorFeatures: OperatorFeaturesFragment;
    clientFeatures: ClientFeatures;
};

type DispatchProps = {
    onClick: (
        campaignType: CampaignType,
        login: string,
        operatorFeatures: OperatorFeaturesFragment,
        clientFeatures: ClientFeatures
    ) => void;
};

type MergedProps = AddCampaignTypeMenuProps;

const mapStateToProps = (state: State): StateProps => {
    const clientLogin = state.commonData.client.login;
    const { availableCampaignTypes = [], operatorFeatures, features: clientFeatures } = state.commonData;

    return {
        clientLogin,
        availableCampaignTypes,
        operatorFeatures,
        clientFeatures
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return {
        onClick(
            campaignType: CampaignType,
            login: string,
            operatorFeatures: OperatorFeaturesFragment,
            clientFeatures: ClientFeatures
        ) {
            const isCampaignAddAllowedInDna = checkIsCampaignAddAllowedInDna(
                campaignType,
                operatorFeatures,
                clientFeatures
            );

            dispatch(closeSidebarMenus());
            dispatch(
                addEntity({
                    type: GridEditedEntityType.Campaign,
                    campaignType,
                    login,
                    isCampaignAddAllowedInDna
                })
            );
        }
    };
};

const mergeProps = (stateProps: StateProps, dispatchProps: DispatchProps): MergedProps => {
    const { clientLogin, operatorFeatures, clientFeatures, ...filteredStateProps } = stateProps;
    const { onClick, ...filteredDispatchProps } = dispatchProps;
    return {
        ...filteredStateProps,
        ...filteredDispatchProps,
        onClick: clientLogin
            ? (type: CampaignType) => {
                  onClick(type, clientLogin, operatorFeatures, clientFeatures);
              }
            : undefined
    };
};

export const AddCampaignTypeMenuContainer = connect<StateProps, DispatchProps, {}, MergedProps>(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(AddCampaignTypeMenu);
